// extracted by mini-css-extract-plugin
export default {"root":"IconTwitter_root__XVxMa"};